/* Shop — All Titles. Commented source: ui_kits/website/shopify/shop/tws-shop.js
   Filters run over the WHOLE catalogue; paging is client-side over the full
   list. The page param is `p`, never `page`, so it cannot collide with
   Liquid's own paginate. */
(function () {
if (window.__twsShopInit) return;
window.__twsShopInit = true;
var $  = function (s, r) { return (r || document).querySelector(s); };
var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
var root = $('.tws-shop');
var grid = $('#shGrid');
if (!root || !grid) return;
var RAW = JSON.parse($('#shData').textContent);
var FEATURED = RAW.featured || {};
function mapRows(rows, offset) {
return rows.map(function (p, i) {
return { h: p[0], t: p[1], v: p[2], g: p[3].split(','), p: p[4],
img: p[5], money: p[6], i: offset + i };
});
}
var ITEMS = mapRows(RAW.products, 0);
var KEYS = ['type', 'genre', 'format', 'collection'];
var GROUP = {
type:       ['solo', 'antho', 'magazine'],
genre:      ['fiction', 'poetry', 'non-fiction'],
format:     ['paperback', 'hardcover', 'digital'],
collection: ['new', 'bundle', 'bestseller']
};
var PARAM = { type: 'type', genre: 'genre', format: 'fmt', collection: 'collection' };
var LABEL = {
solo: 'Solo books', antho: 'Anthologies', magazine: 'Magazines',
fiction: 'Fiction', poetry: 'Poetry', 'non-fiction': 'Non-fiction',
paperback: 'Paperback', hardcover: 'Hardcover', digital: 'Digital',
'new': 'New this season', bundle: 'Bundles', bestseller: 'Bestsellers'
};
var TYPE_ONE = { solo: 'Solo book', antho: 'Anthology', magazine: 'Magazine' };
var NEW_LIMIT = { solo: 12, magazine: 3 };
var NEW_SET = {};
function rebuildNew() {
var seen = { solo: 0, magazine: 0 };
NEW_SET = {};
ITEMS.slice().sort(function (a, b) { return a.i - b.i; }).forEach(function (p) {
['solo', 'magazine'].forEach(function (t) {
if (p.g.indexOf(t) !== -1 && seen[t] < NEW_LIMIT[t]) { seen[t]++; NEW_SET[p.i] = 1; }
});
});
}
rebuildNew();
function hasFacet(p, key, val) {
if (key === 'collection') return val === 'new' ? !!NEW_SET[p.i] : p.g.indexOf(val) !== -1;
return p.g.indexOf(val) !== -1;
}
var active = { type: [], genre: [], format: [], collection: [] };
var PER    = parseInt(grid.getAttribute('data-per'), 10) || 36;
var page   = 1;
function esc(s) {
return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
.replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function renderCard(p, idx) {
var type = p.g.filter(function (t) { return TYPE_ONE[t]; })[0];
var fmts = ['paperback', 'hardcover', 'digital'].filter(function (f) { return p.g.indexOf(f) !== -1; });
var lbl  = [TYPE_ONE[type] || 'Title'].concat(fmts.map(function (f) { return LABEL[f]; })).join(' · ');
var cta  = fmts.length > 1 ? 'Choose format' : 'Add to cart';
var url  = '/products/' + p.h;
return '' +
'<article class="sh-pc" data-i="' + p.i + '" style="--d:' + ((idx % 4) * 70) + 'ms"' +
' itemscope itemtype="https://schema.org/Product">' +
'<a class="sh-link" href="' + url + '">' +
'<span class="sh-fig">' +
'<img src="' + esc(p.img) + '" alt="' + esc(p.t) + ' — book cover"' +
' loading="lazy" decoding="async" width="600" height="600">' +
'<span class="sh-quick" aria-hidden="true">View book</span>' +
'</span>' +
'<span class="sh-lbl">' + esc(lbl) + '</span>' +
'<h3 class="sh-t" itemprop="name">' + esc(p.t) + '</h3>' +
'<span class="sh-a" itemprop="brand">' + esc(p.v) + '</span>' +
'<span class="sh-p" itemprop="offers" itemscope itemtype="https://schema.org/Offer">' +
'<meta itemprop="priceCurrency" content="PKR"><meta itemprop="price" content="' + p.p + '">' +
esc(p.money) +
'</span>' +
'</a>' +
'<a class="sh-add" href="' + url + '">' + cta + '</a>' +
'</article>';
}
function readURL() {
var q = new URLSearchParams(location.search);
KEYS.forEach(function (k) {
var v = q.get(PARAM[k]);
active[k] = v ? v.split(',').map(function (s) { return s.trim(); })
.filter(function (s) { return GROUP[k].indexOf(s) !== -1; }) : [];
});
var s = q.get('sort');
var sortEl = $('#shSort');
if (sortEl && s && ['featured', 'new', 'asc', 'desc'].indexOf(s) !== -1) sortEl.value = s;
var pg = parseInt(q.get('p'), 10);
page = (pg && pg > 0) ? pg : 1;
}
function writeURL(push) {
var q = new URLSearchParams();
KEYS.forEach(function (k) { if (active[k].length) q.set(PARAM[k], active[k].join(',')); });
var sortEl = $('#shSort');
if (sortEl && sortEl.value !== 'featured') q.set('sort', sortEl.value);
if (page > 1) q.set('p', String(page));
var url = location.pathname + (q.toString() ? '?' + q.toString() : '') + location.hash;
if (push) history.pushState({ shop: 1 }, '', url);
else history.replaceState({ shop: 1 }, '', url);
}
function matches(p) {
return KEYS.every(function (k) {
if (!active[k].length) return true;
return active[k].some(function (v) { return hasFacet(p, k, v); });
});
}
function facetCount(key, val) {
return ITEMS.filter(function (p) {
if (!hasFacet(p, key, val)) return false;
return KEYS.every(function (k) {
if (k === key || !active[k].length) return true;
return active[k].some(function (v) { return hasFacet(p, k, v); });
});
}).length;
}
function sortList(list) {
var mode = ($('#shSort') || {}).value || 'featured';
var out = list.slice();
if (mode === 'asc') out.sort(function (a, b) { return a.p - b.p || a.i - b.i; });
else if (mode === 'desc') out.sort(function (a, b) { return b.p - a.p || a.i - b.i; });
else if (mode === 'new') out.sort(function (a, b) { return a.i - b.i; });
else out.sort(function (a, b) {
var fa = FEATURED[a.h], fb = FEATURED[b.h];
if (fa != null && fb != null) return fa - fb;
if (fa != null) return -1;
if (fb != null) return 1;
return a.i - b.i;
});
return out;
}
function apply(pushState) {
var list = sortList(ITEMS.filter(matches));
var total = list.length;
var totalPages = Math.max(1, Math.ceil(total / PER));
if (page > totalPages) page = totalPages;
if (page < 1) page = 1;
var start = (page - 1) * PER;
var slice = list.slice(start, start + PER);
grid.innerHTML = slice.map(renderCard).join('');
$('#shCount').textContent = total === 0 ? 'No titles'
: total === 1 ? 'Showing 1 title'
: totalPages > 1
? 'Showing ' + (start + 1) + '–' + (start + slice.length) + ' of ' + total + ' titles'
: 'Showing all ' + total + ' titles';
renderPager(page, totalPages);
var applyC = $('#shApplyCount'); if (applyC) applyC.textContent = String(total);
var nSel = KEYS.reduce(function (n, k) { return n + active[k].length; }, 0);
var dC = $('#shDrawerCount'); if (dC) dC.textContent = nSel ? '(' + nSel + ')' : '';
$('#shEmpty').style.display = total ? 'none' : '';
grid.style.display = total ? '' : 'none';
$$('.sh-fo em[data-n]').forEach(function (em) {
var input = em.parentNode.querySelector('input');
em.textContent = facetCount(input.getAttribute('data-key'), input.value);
});
$$('.sh-fo input').forEach(function (b) {
b.checked = active[b.getAttribute('data-key')].indexOf(b.value) !== -1;
});
var chips = $('#shChips'), h = '';
KEYS.forEach(function (k) {
active[k].forEach(function (v) {
h += '<button type="button" class="sh-chip" data-key="' + k + '" data-value="' + v + '"' +
' aria-label="Remove filter ' + esc(LABEL[v] || v) + '">' + esc(LABEL[v] || v) +
'<b aria-hidden="true">&#215;</b></button>';
});
});
if (nSel > 1) h += '<button type="button" class="sh-chip sh-chip-clear" data-key="all">Clear all</button>';
chips.innerHTML = h;
chips.style.marginTop = nSel ? '16px' : '0';
document.title = nSel
? KEYS.reduce(function (a, k) { return a.concat(active[k].map(function (v) { return LABEL[v]; })); }, []).join(', ')
+ ' — Shop — TWS Publications'
: 'Shop All Books, Anthologies & Magazines — TWS Publications';
writeURL(pushState);
armUnstick();
}
function pageWindow(cur, total) {
if (total <= 7) {
var all = []; for (var i = 1; i <= total; i++) all.push(i); return all;
}
var s = cur - 1, e = cur + 1;
if (cur <= 3) { s = 2; e = 4; }
else if (cur >= total - 2) { s = total - 3; e = total - 1; }
var out = [1];
if (s > 2) out.push('gap');
for (var j = Math.max(2, s); j <= Math.min(total - 1, e); j++) out.push(j);
if (e < total - 1) out.push('gap');
out.push(total);
return out;
}
function renderPager(cur, total) {
var pager = $('#shPager');
$('#shPageOf').textContent = total > 1 ? 'Page ' + cur + ' of ' + total : '';
if (total <= 1) { $('#shPageNums').innerHTML = ''; pager.style.display = 'none'; return; }
pager.style.display = '';
$('#shPageNums').innerHTML = pageWindow(cur, total).map(function (n) {
if (n === 'gap') return '<span class="sh-pg-gap" aria-hidden="true">&hellip;</span>';
var isCur = n === cur;
return '<button type="button" class="sh-pg" data-page="' + n + '"' +
(isCur ? ' aria-current="page"' : '') +
' aria-label="' + (isCur ? 'Current page, page ' : 'Go to page ') + n + '">' + n + '</button>';
}).join('');
$$('.sh-pg-arrow', pager).forEach(function (b) {
var isPrev = b.getAttribute('data-rel') === 'prev';
b.disabled = isPrev ? cur <= 1 : cur >= total;
});
}
function goToPage(n) {
page = n;
apply(true);
var top = document.getElementById('grid');
if (top) {
var y = top.getBoundingClientRect().top + window.scrollY - 90;
window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
}
var first = grid.querySelector('.sh-link');
if (first) first.focus({ preventScroll: true });
}
$('#shPager').addEventListener('click', function (e) {
var b = e.target.closest('button'); if (!b || b.disabled) return;
if (b.hasAttribute('data-page')) {
var n = parseInt(b.getAttribute('data-page'), 10);
if (n !== page) goToPage(n);
return;
}
var rel = b.getAttribute('data-rel');
if (rel === 'prev') goToPage(page - 1);
if (rel === 'next') goToPage(page + 1);
});
function refilter() { page = 1; apply(true); }
function buildInputs() {
$$('.sh-fo input').forEach(function (b) {
b.addEventListener('change', function () {
var k = b.getAttribute('data-key'), list = active[k], i = list.indexOf(b.value);
if (b.checked && i === -1) list.push(b.value);
if (!b.checked && i !== -1) list.splice(i, 1);
refilter();
});
});
}
$('#shChips').addEventListener('click', function (e) {
var btn = e.target.closest('[data-key]'); if (!btn) return;
if (btn.getAttribute('data-key') === 'all') return clearAll();
var k = btn.getAttribute('data-key'), v = btn.getAttribute('data-value');
var i = active[k].indexOf(v); if (i !== -1) active[k].splice(i, 1);
refilter();
});
function clearAll() {
KEYS.forEach(function (k) { active[k] = []; });
refilter();
}
$$('.sh-clear').forEach(function (b) { b.addEventListener('click', clearAll); });
$('#shSort').addEventListener('change', refilter);
function setDrawer(on) {
document.body.classList.toggle('sh-drawer-open', on);
$('#shDrawerOpen').setAttribute('aria-expanded', on ? 'true' : 'false');
if (on) $('#shDrawerClose').focus({ preventScroll: true });
else $('#shDrawerOpen').focus({ preventScroll: true });
}
$('#shDrawerOpen').addEventListener('click', function () { setDrawer(true); });
$('#shDrawerClose').addEventListener('click', function () { setDrawer(false); });
$('#shDrawerApply').addEventListener('click', function () { setDrawer(false); });
$('#shScrim').addEventListener('click', function () { setDrawer(false); });
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && document.body.classList.contains('sh-drawer-open')) setDrawer(false);
});
addEventListener('popstate', function () {
readURL();
apply(false);
});
function unstick() {
$$('.sh-pc, .sh-rule', root).forEach(function (el) {
var cs = getComputedStyle(el);
if (parseFloat(cs.opacity) < 0.99 || cs.transform === 'matrix(0, 0, 0, 1, 0, 0)') {
el.style.animation = 'none';
}
});
}
var unstickTimer = null;
function armUnstick() {
if (unstickTimer) clearTimeout(unstickTimer);
unstickTimer = setTimeout(unstick, 1600);
}
document.addEventListener('visibilitychange', function () {
if (document.visibilityState === 'visible') armUnstick();
});
addEventListener('pageshow', armUnstick);
function splitWords() {
$$('h1', root).forEach(function (h) {
if (h.getAttribute('data-split')) return;
h.setAttribute('data-split', '1');
(function wrap(el) {
Array.prototype.slice.call(el.childNodes).forEach(function (n) {
if (n.nodeType === 3) {
if (!n.textContent.trim()) return;
var frag = document.createDocumentFragment();
n.textContent.split(/(\s+)/).forEach(function (p) {
if (!p) return;
if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
var s = document.createElement('span'); s.className = 'sw';
var i = document.createElement('i'); i.textContent = p;
s.appendChild(i); frag.appendChild(s);
});
n.parentNode.replaceChild(frag, n);
} else if (n.nodeType === 1 && !n.hasAttribute('data-nosplit')
&& !n.classList.contains('sw') && n.tagName !== 'svg'
&& n.tagName !== 'BUTTON' && n.tagName !== 'A') { wrap(n); }
});
})(h);
$$('.sw', h).forEach(function (w, i) {
w.classList.add('on');
w.firstChild.style.animationDelay = (i * 52) + 'ms';
});
});
}
function hydrate() {
var pages = RAW.pages || 1;
if (pages < 2 || typeof fetch === 'undefined') return;
for (var n = 2; n <= pages; n++) {
(function (pg) {
fetch(location.pathname + '?section_id=' + RAW.dataSection + '&page=' + pg,
{ credentials: 'same-origin' })
.then(function (r) { return r.ok ? r.text() : null; })
.then(function (html) {
if (!html) return;
var m = html.match(/id="shDataRows"[^>]*>([\s\S]*?)<\/script>/);
if (!m) return;
var rows = JSON.parse(m[1]);
if (!rows.length) return;
ITEMS = ITEMS.concat(mapRows(rows, (pg - 1) * (RAW.perPage || 250)));
rebuildNew();
apply(false);
})
.catch(function () {  });
})(n);
}
}
function boot() {
readURL();
buildInputs();
apply(false);
splitWords();
hydrate();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
})();
